import React from 'react';
import type { PeriodType } from '@/types/reporting-v2';

interface PeriodTypeSelectorProps {
  value: PeriodType;
  onChange: (value: PeriodType) => void;
  options?: PeriodType[];
}

const DEFAULT_OPTIONS: PeriodType[] = ['daily', 'weekly', 'monthly', 'quarterly', 'yearly', 'custom'];

export default function PeriodTypeSelector({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
}: PeriodTypeSelectorProps) {
  return (
    <div className="flex gap-2 flex-wrap">
      {options.map((period) => (
        <button
          key={period}
          onClick={() => onChange(period)}
          className={`px-3 py-1.5 text-sm font-medium rounded-lg capitalize transition-colors ${
            value === period
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {period}
        </button>
      ))}
    </div>
  );
}
